<template>
  <el-form :rules="rules" label-position="top" ref="form" :model="data">
    <el-row>
      <el-col :span='24'>
        <el-form-item label="代码标识" prop="sc_code">
          <el-input type="textarea" v-model="data.sc_code"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span='24'>
        <el-form-item label="代码描述" prop="sc_name">
          <el-input type="textarea" v-model="data.sc_name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span='24'>
        <el-form-item label="代码名称" prop="sc_key">
          <el-input type="textarea" v-model="data.sc_key"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span='24'>
        <el-form-item label="代码值" prop="sc_value">
          <el-input type="textarea" v-model="data.sc_value"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span='24'>
        <el-form-item label="代码顺序" prop="sc_order">
          <el-input-number type="textarea" min="0" v-model.number="data.sc_order"></el-input-number>
        </el-form-item>
      </el-col>
      <el-col :span='24'>
        <el-form-item label="有效性" prop="sc_status">
          <el-select filterable v-model="data.sc_status" placeholder="请选择">
            <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span='24'>
        <el-form-item label="备注" prop="opcomment">
          <el-input type="textarea" v-model="data.opcomment"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import SysCodeApi from "./SysCode";

export default {
  props: {
    dat: {}
  },
  data() {
    var validateInput = (rule, value, callback) => {
      if (!this.checkSpecificKey(value)) {
        callback(new Error("存在特殊字符"));
      } else {
        callback();
      }
    };
    return {
      data: {
        uuid: "",
        sc_code: "",
        sc_name: "",
        sc_key: "",
        sc_value: "",
        sc_order: 1,
        sc_status: "",
        opcomment: ""
      },
      options: [
        {
          key: "1",
          value: "有效"
        },
        {
          key: "0",
          value: "无效"
        }
      ],
      rules: {
        sc_code: [
          { required: true, message: "请输入代码标识" },
          { validator: validateInput, trigger: ["blur", "change"] },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 25 个字符以内",
            trigger: "blur"
          }
        ],
        sc_value: [
          { required: true, message: "请输入代码值" },
          { validator: validateInput, trigger: ["blur", "change"] },
          {
            min: 1,
            max: 40,
            message: "长度在 1 到 40 个字符以内",
            trigger: "blur"
          }
        ],
        sc_name: [
          { required: true, message: "请输入代码描述" },
          { validator: validateInput, trigger: ["blur", "change"] },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 25 个字符以内",
            trigger: "blur"
          }
        ],
        sc_key: [
          { required: true, message: "请输入代码名称" },
          { validator: validateInput, trigger: ["blur", "change"] },
          {
            max: 25,
            message: "长度在 1 到 25 个字符以内",
            trigger: "blur"
          }
        ],
        opcomment: [
          {
            min: 0,
            max: 100,
            message: "长度在 0 到 100 个字符以内",
            trigger: "blur"
          }
        ]
      }
    };
  },
  // 当前组件显示到页面之后立即执行，（挂载到页面）
  mounted() {
    this.loadInfo();
  },
  watch: {
    dat: function() {
      this.loadInfo();
    }
  },
  methods: {
    checkSpecificKey(str) {
      let specialKey = "[`~!#$^&*()=|{}':;',\\[\\].<>/?~！#￥……&*（）——|{}【】‘；”“'。，、？]‘'";
      for (let i = 0; i < str.length; i++) {
        if (specialKey.indexOf(str.substr(i, 1)) != -1) {
          return false;
        }
      }
      return true;
    },
    loadInfo() {
      this.data.uuid = this.dat.uuid;
      this.data.sc_code = this.dat.sccode;
      this.data.sc_name = this.dat.scname;
      this.data.sc_key = this.dat.sckey;
      this.data.sc_value = this.dat.scvalue;
      this.data.sc_order = this.dat.scorder;
      this.data.sc_status = this.dat.scstatus;
      this.data.opcomment = this.dat.opcomment;
      if (!this.dat.uuid) {
        this.data.uuid = "";
        this.data.sc_code = "";
        this.data.sc_name = "";
        this.data.sc_key = "";
        this.data.sc_value = "";
        this.data.sc_order = "1";
        this.data.sc_status = "";
        this.data.opcomment = "";
      }
    },
    async saveSysCode() {
      await this.$refs["form"].validate();
      if(this.data.uuid) {
        await SysCodeApi.updateSysCode(this.data);
      } else {
        await SysCodeApi.saveSysCode(this.data);
      }
      this.$emit("upd");
    }
  }
};
</script>

<style>
</style>
